function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { COMPLETE_SLIDE, logError, getCompletedSlides } from "../actions";
var setVisited = function(nodeId, status, api) {
    var suspendData = api ? api.getSuspendData() : {};
    var visitedNodes = suspendData.v || [];
    var index = visitedNodes.findIndex(function(param) {
        var _param = _slicedToArray(param, 1), id = _param[0];
        return id === nodeId;
    });
    if (index !== -1) {
        if (visitedNodes[index][1] !== status) {
            visitedNodes[index][1] = status;
        }
    } else {
        visitedNodes.push([
            nodeId,
            status
        ]);
    }
    return {
        e: suspendData.e ? suspendData.e : [],
        f: suspendData.f ? suspendData.f : [],
        kv: suspendData.kv ? suspendData.kv : {},
        p: suspendData.p ? suspendData.p : "0%",
        v: visitedNodes
    };
};
export default function setCompleted(action$, state$) {
    return action$.pipe(ofType(COMPLETE_SLIDE), map(function(action) {
        if (state$.value.api) {
            state$.value.api.setSlideStatus(action.id, action.status || "completed");
            var suspendData = setVisited(action.id, action.status || "completed", state$.value.api);
            state$.value.api.setSuspendData(suspendData);
        }
        return !state$.value.api ? logError({
            error: new Error("No LMS API found"),
            key: "no_api"
        }) : getCompletedSlides();
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "complete_slide"
        }));
    }));
}
